import { render, staticRenderFns } from "./ItemCard.vue?vue&type=template&id=3c516636&scoped=true&"
import script from "./ItemCard.vue?vue&type=script&lang=ts&"
export * from "./ItemCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c516636",
  null
  
)

export default component.exports